import React, { useMemo, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PackageCard from '../components/PackageCard';
import { categories, packages } from '../mock';
import { Search } from 'lucide-react';
import { Input } from '../components/ui/input';

export default function PackagesPage() {
  const [activeCat, setActiveCat] = useState('All');
  const [q, setQ] = useState('');

  const filtered = useMemo(() => {
    let list = activeCat === 'All' ? packages : packages.filter((p) => p.category === activeCat);
    if (q.trim()) list = list.filter((p) => (p.title + ' ' + p.highlights).toLowerCase().includes(q.toLowerCase()));
    return list;
  }, [activeCat, q]);

  return (
    <div className="bg-white">
      <Header />

      {/* Page Banner */}
      <section className="bg-navy text-white" style={{ backgroundColor: '#061228' }}>
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-20 text-center">
          <span className="eyebrow text-orange-300 border-orange-300/40 bg-orange-300/10">All Packages</span>
          <h1 className="mt-4 font-serif text-4xl md:text-5xl font-bold">Explore <span className="accent-word">India</span> Your Way</h1>
          <p className="mt-3 text-blue-100/80 max-w-2xl mx-auto">Choose from {packages.length}+ hand-crafted tour packages — spiritual yatras, hill escapes, beach holidays & cultural circuits.</p>
        </div>
      </section>

      <section className="section bg-slate-50">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-4 lg:items-center justify-between mb-8">
            <div className="flex flex-wrap gap-2.5">
              {categories.map((c) => (
                <button key={c} onClick={() => setActiveCat(c)} className={`chip ${activeCat === c ? 'chip-active' : ''}`}>{c}</button>
              ))}
            </div>
            <div className="relative max-w-sm w-full">
              <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search destinations..." className="pl-9 bg-white" />
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((p) => <PackageCard key={p.id} pkg={p} />)}
          </div>

          {filtered.length === 0 && (
            <div className="text-center py-20 text-slate-500">No packages match your search. Try a different keyword.</div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
